export default "__VITE_ASSET__DEW52mI5__"